<template>
    <div>
        <!-- LogoutConfirm Component -->
    </div>
</template>

<script>
import { suppliosApi } from '../../js/api-service';

export default {
    name: 'LogoutConfirm',
    components: {},
    i18n: {
        messages: {
            en: {
                logoutConfirm: {
                    confirmMessage: 'Are you sure you want to logout?',
                    title: 'Logout?',
                    okTitle: 'Yes, Logout',
                    cancelTitle: 'No, Cancel',
                    logoutError: 'Error while trying to logout',
                },
            },
            es: {
                logoutConfirm: {
                    confirmMessage: '¿Está seguro de que desea cerrar sesión?',
                    title: '¿Cerrar sesión?',
                    okTitle: 'Sí, cerrar sesión',
                    cancelTitle: 'No, cancelar',
                    logoutError: 'Error al intentar cerrar sesión',
                },
            },
            pt: {
                logoutConfirm: {
                    confirmMessage: 'Tem certeza de que deseja sair?',
                    title: 'Sair?',
                    okTitle: 'Sim, sair',
                    cancelTitle: 'Não, cancelar',
                    logoutError: 'Erro ao tentar sair',
                },
            },
            'zh-Hans': {
                logoutConfirm: {
                    confirmMessage: '您确定要退出登录吗？',
                    title: '退出登录？',
                    okTitle: '是，退出登录',
                    cancelTitle: '否，取消',
                    logoutError: '退出登录时出错',
                },
            },
            'zh-Hant': {
                logoutConfirm: {
                    confirmMessage: '您確定要登出嗎？',
                    title: '登出？',
                    okTitle: '是，登出',
                    cancelTitle: '否，取消',
                    logoutError: '登出時發生錯誤',
                },
            },
        },
    },
    props: {
        
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
        }
    },
    computed: {

    },
    methods: {
        logout: function() {
            // show a confirm modal, then if user clicks "logout" call performLogout to actually do it
            this.$bvModal.msgBoxConfirm(this.$t('logoutConfirm.confirmMessage'), {
                title: this.$t('logoutConfirm.title'),
                size: 'sm',
                buttonSize: 'md',
                okVariant: 'primary',
                okTitle: this.$t('logoutConfirm.okTitle'),
                cancelTitle: this.$t('logoutConfirm.cancelTitle'),
                bodyClass: 'text-center',
                headerClass: '',
                footerClass: 'p-2 border-top-0 justify-content-center',
                hideHeaderClose: false,
                centered: true
            })
            .then(value => {
                if (value) {  // if user clicks on "ok / yes" then value will be true, otherwise value will be false or undefined
                    this.performLogout();
                }
            })
        },
        performLogout: function() {
            // actually do the logout - do a POST to the logout link
            suppliosApi.auth.logout()
            .then(response => {
                // response.data will be a JSON object with URL to redirect to, as per your django & allauth settings {location: '/the-appropriate-redirect-url/'}
                console.log('Response from logout');
                console.log(response);
                let logoutRedirectUrl = response.data.location;
                if (logoutRedirectUrl) {
                    window.location.replace(logoutRedirectUrl);
                }
            })
            .catch(err => {
                this.handleError(err, this.$t('logoutConfirm.logoutError'));
            })
        },
        handleError: function(error, message) {
            console.log(message);
            console.log(error);
            this.errorMsg = message;
            this.error = true;
            this.$toast.error(message, {timeout: false});
        },
    }
}
</script>

<style>

</style>